import { environment } from '../../environments/environment'
import { phcURLs } from '../../assets/content/phc-urls.content'
import { PhcUrl } from '../models/interfaces/portfolio-health-check-data'

export const getPHCUrls = () => {
    const envType = environment.EXTERNAL ? 'external' : 'internal'
    return phcURLs[environment.DEPLOYMENT][envType] as PhcUrl
}

export function camelToKebabCase(camelCaseString: string): string {
    return camelCaseString
        .replace(/([a-z])([A-Z])/g, '$1-$2')
        .toLowerCase();
}

export function convertFloatToInt(value: number, precision = 2) {
    const [wholePart, decimalPart] = String(value).split('.')
    return +(
        wholePart + (
            decimalPart ? (
                decimalPart.length < precision ? decimalPart.padEnd(precision, '0') :
                    decimalPart
            ) :
                ''.padEnd(precision, '0')
        )
    )
}

export function convertIntToFloat(value: number, precision = 2) {
    return value / (Math.pow(10, precision))
}